import { defineComponent } from "vue";
import { xhrRequest, xhrErrors } from "utils/xhr";
import Spinner from "utils/spinner";
import { format } from 'date-fns';
import validationErrors from "components/base/validation_errors";
import viewer from "./viewer";

const onInit = () => { };

const onMounted = function () {
};

const methods = {
  onDownloadClick: function (e) {
    this.$refs.viewer.download();
  },
  onCurrentPageChange: function (currentPage) {
    this.currentPage = currentPage;
  },
  onTotalPagesChange: function (totalPages) {
    this.totalPages = totalPages;
  },
  onPrevClick: function (e) {
    if (this.currentPage <= 1) return;
    this.$refs.viewer.setPage(this.currentPage - 1);
  },
  onNextClick: function (e) {
    if (this.currentPage >= this.totalPages) return;
    this.$refs.viewer.setPage(this.currentPage + 1);
  },
  onZoomIn: function () {
    let zoom = this.zoom + 10;
    if (zoom > 100) zoom = 100;
    this.zoom = zoom;
  },
  onZoomOut: function () {
    let zoom = this.zoom - 10;
    if (zoom < 50) zoom = 50;
    this.zoom = zoom;
  },
};

const computed = {
  hasPrev: function () {
    return this.currentPage > 1;
  },
  hasNext: function () {
    return this.currentPage < this.totalPages;
  }
};

export default defineComponent({
  template: "#container",
  components: { "viewer": viewer },
  data: () => {
    return {
      currentPage: 1,
      totalPages: 0,
      zoom: 80,
    }
  },
  props: {
    workerSrc: {
      type: String,
      require: true,
    }
  },
  created: onInit,
  mounted: onMounted,
  methods: methods,
  computed: computed,
});
